/**
 * Which safety UI is open: the 2D player card / report dialog / people sheet
 * (desktop + mobile, rendered by SafetyOverlay in its own React root), or the
 * VR panel (rendered in the scene by VRSafetyHost while an XR session runs).
 */
import { create } from 'zustand';
import type { SafetyTarget } from '../services/safety';

export type SafetyView =
  | { kind: 'card'; target: SafetyTarget }
  | { kind: 'report'; target: SafetyTarget }
  | { kind: 'people' };

interface SafetyUiState {
  /** 2D overlay (desktop / mobile). */
  view: SafetyView | null;
  /** In-headset panel. */
  vrView: SafetyView | null;
  /** Bumped each time the VR panel is (re)opened so it re-anchors in front of you. */
  vrOpenedAt: number;
  toast: { text: string; at: number } | null;
}

export const useSafetyUi = create<SafetyUiState>(() => ({ view: null, vrView: null, vrOpenedAt: 0, toast: null }));

export const showSafetyToast = (text: string) => useSafetyUi.setState({ toast: { text, at: Date.now() } });
